import {mix} from 'polished';
import {Option as OptionInterface} from '../../contexts/Quote';
import {OPTION_GROUP_CHECK_TYPE} from './static';

const commonRules = {
  groovedBlowhole: 'DBC_Event_rainure',
  antibacterialVarnish: 'OPT_foption01',
};

export enum PRODUCT_CATEGORY {
  CLASSIQUE = 'Classique',
  DEPORTE = 'Deporte',
  PROTECTION = 'Protection',
}

export enum CLASSIQUE_SHAPE {
  CONDUIT = 'Classique_Conduit',
  CANULE_EPAULEMENT = 'Classique_CanuleEpaulement',
  CANULE_DEMI_EPAULEMENT = 'Classique_CanuleDemiEpaulement',
  SQUELETTE = 'Classique_Squelette',
  FOND_CONQUE = 'Classique_FondConque',
  DEMI_CONQUE = 'Classique_DemiConque',
  PINCE_CRABE = 'Classique_PinceCrabe',
}

export enum CLASSIQUE_MATERIAL {
  RESINE_3D = 'Classique_Resine3D',
  PLATINUM_25_SH = 'Classique_Platinum25sh',
  PLATINUM_40_SH = 'Classique_Platinum40sh',
  PLATINUM_60_SH = 'Classique_Platinum60sh',
}
export const classiqueShapeRule: {
  [material in CLASSIQUE_SHAPE]:
    | string
    | ((material: CLASSIQUE_MATERIAL) => string);
} = {
  [CLASSIQUE_SHAPE.CONDUIT]: 'conduitSimple',
  [CLASSIQUE_SHAPE.CANULE_EPAULEMENT]: 'conduitEpaule',
  [CLASSIQUE_SHAPE.CANULE_DEMI_EPAULEMENT]: 'conduitDemiEpaule',
  [CLASSIQUE_SHAPE.SQUELETTE]: 'phantomold',
  [CLASSIQUE_SHAPE.FOND_CONQUE]: 'coquille',
  [CLASSIQUE_SHAPE.DEMI_CONQUE]: 'coquille',
  [CLASSIQUE_SHAPE.PINCE_CRABE]: 'silouhette',
};

export const classiqueMaterialPrefix: {
  [material in CLASSIQUE_MATERIAL]?: string;
} = {
  [CLASSIQUE_MATERIAL.RESINE_3D]: 'RES',
  [CLASSIQUE_MATERIAL.PLATINUM_25_SH]: 'SIL',
  [CLASSIQUE_MATERIAL.PLATINUM_40_SH]: 'SIL',
  [CLASSIQUE_MATERIAL.PLATINUM_60_SH]: 'SIL',
};

export const classiqueMaterialRule: {
  [material in CLASSIQUE_MATERIAL]: string;
} = {
  [CLASSIQUE_MATERIAL.RESINE_3D]: 'resineIP',
  [CLASSIQUE_MATERIAL.PLATINUM_25_SH]: 'silicone3D25',
  [CLASSIQUE_MATERIAL.PLATINUM_40_SH]: 'silicone3D40',
  [CLASSIQUE_MATERIAL.PLATINUM_60_SH]: 'platinium60',
};

export enum DEPORTE_BRAND {
  SIEMENS = 'Deporte_Siemens',
  OTICON = 'Deporte_Oticon',
  BELTONE = 'Deporte_Beltone',
  WIDEX = 'Deporte_Widex',
  PHONAK = 'Deporte_Phonak',
  STARKEY = 'Deporte_Starkey',
}

export enum DEPORTE_SHAPE {
  DEPORTE = 'Deporte_Embouts',
  CANULE_AERO = 'Deporte_CanuleAero',
  COQUE = 'Deporte_Coque',

  DEPORTE_CONDUIT = 'DEPORTE_CONDUIT',
  DEPORTE_PHANTOMOLD = 'DEPORTE_PHANTOMOLD',
  DEPORTE_COQUILLE = 'DEPORTE_COQUILLE',
  DEPORTE_HALF_CONQUE = 'DEPORTE_HALF_CONQUE',
  DEPORTE_SILHOUETTE = 'DEPORTE_SILHOUETTE',

  AERO_CANULE = 'Aero_Canule',
  AERO_SKELETON = 'Aero_Squelette',

  CRAB_CANULE = 'Crab_Canule',
}

export enum DEPORTE_MATERIAL {
  RESINE_3D = 'Deporte_Canule_Resine3D',
  SILICON_PLATNIUM_40 = 'Deporte_Canule_SiliconPlatinum40',
}

export const deporteMaterialRule: {[material in DEPORTE_MATERIAL]: string} = {
  [DEPORTE_MATERIAL.RESINE_3D]: 'resineIP',
  [DEPORTE_MATERIAL.SILICON_PLATNIUM_40]: 'silicone3D40',
};

export const deporteShapeRule: {
  [material in DEPORTE_SHAPE]?: string;
} = {
  [DEPORTE_SHAPE.DEPORTE_CONDUIT]: 'conduit',
  [DEPORTE_SHAPE.DEPORTE_PHANTOMOLD]: 'phantomold',
  [DEPORTE_SHAPE.DEPORTE_COQUILLE]: 'coquille',
  [DEPORTE_SHAPE.DEPORTE_HALF_CONQUE]: 'demiconque',
  [DEPORTE_SHAPE.DEPORTE_SILHOUETTE]: 'silhouette',
  [DEPORTE_SHAPE.AERO_CANULE]: 'AER_canule',
  [DEPORTE_SHAPE.AERO_SKELETON]: 'AER_squelette',
  [DEPORTE_SHAPE.CRAB_CANULE]: 'COQ_canule',
};

export enum PROTECTION_SHAPE {
  SOMMEIL = 'Protection_Sommeil',
  SWEETNIGHT = 'Protection_Sweetnight',
  AQUASTOP = 'Protection_Aquastop',
  OBTURATEUR = 'Protection_Obturateur',
  GAME_EAR = 'Protection_GameEar',
  PASSTOP_A = 'Protection_PasstopA',
  PASSTOP_OR = 'Protection_PasstopOr',
  AQUASON = 'Protection_Aquason',
  PASSTOP_EP2 = 'Protection_PasstopEP2',
}

export enum COLOR {
  RED = 'RED',
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  WHITE = 'WHITE',
  BLACK = 'BLACK',
  ORANGE = 'ORANGE',
  COLORLESS_TRANSLUCENT = 'COLORLESS_TRANSLUCENT',
  ROSE_TRANSLUCENT = 'ROSE_TRANSLUCENT',
  BROWN = 'BROWN',
  ROSE = 'ROSE',
  PASSTOP_OR_BLUE = 'PASSTOP_OR_BLUE',

  BLACK_OPAQUE = 'BLACK_OPAQUE',
  GREEN_TRANSLUCENT = 'GREEN_TRANSLUCENT',
  BLUE_TRANSLUCENT = 'BLUE_TRANSLUCENT',
}

export const colorLabels: {[key in COLOR]: string} = {
  [COLOR.RED]: 'Rouge',
  [COLOR.BLUE]: 'Bleu',
  [COLOR.PASSTOP_OR_BLUE]: 'Bleu',
  [COLOR.YELLOW]: 'Jaune',
  [COLOR.GREEN]: 'Vert',
  [COLOR.WHITE]: 'Blanc',
  [COLOR.BLACK]: 'Noir',
  [COLOR.ORANGE]: 'Orange',
  [COLOR.COLORLESS_TRANSLUCENT]: 'Incolore translucide',
  [COLOR.ROSE_TRANSLUCENT]: 'Rosé translucide',
  [COLOR.ROSE]: 'Rosé',
  [COLOR.BROWN]: 'Marron',

  [COLOR.BLACK_OPAQUE]: 'Noir opaque',
  [COLOR.GREEN_TRANSLUCENT]: 'Vert translucide',
  [COLOR.BLUE_TRANSLUCENT]: 'Bleu translucide',
};

export const colorHex: {[key in COLOR]: string} = {
  [COLOR.RED]: '#FF3C44',
  [COLOR.BLUE]: '#2922ff',
  [COLOR.PASSTOP_OR_BLUE]: '#2922ff',
  [COLOR.GREEN]: '#2BCF29',
  [COLOR.YELLOW]: '#dcc600',
  [COLOR.WHITE]: '#ffffff',
  [COLOR.BLACK]: '#000000',
  [COLOR.ORANGE]: '#ff8500',

  [COLOR.COLORLESS_TRANSLUCENT]: mix(0.5, '#ffffff', 'white'),
  [COLOR.ROSE_TRANSLUCENT]: mix(0.5, '#ffc1cb', 'white'),
  [COLOR.ROSE]: '#ffc1cb',
  [COLOR.BROWN]: '#bf6000',

  [COLOR.BLACK_OPAQUE]: '#000000',
  [COLOR.GREEN_TRANSLUCENT]: mix(0.5, '#2BCF29', 'white'),
  [COLOR.BLUE_TRANSLUCENT]: mix(0.5, '#2922ff', 'white'),
};

export enum CORD_COLOR {
  BLACK = 'BLACK',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  ORANGE = 'ORANGE',
}

export const cordColorLabels: {[key in CORD_COLOR]: string} = {
  [CORD_COLOR.BLACK]: 'Cordon Noir',
  [CORD_COLOR.GREEN]: 'Cordon Vert',
  [CORD_COLOR.BLUE]: 'Cordon Bleu',
  [CORD_COLOR.ORANGE]: 'Cordon Orange',
};

export const cordColorHex: {[key in CORD_COLOR]: string} = {
  [CORD_COLOR.BLACK]: '#000000',
  [CORD_COLOR.GREEN]: '#2BCF29',
  [CORD_COLOR.BLUE]: '#2922ff',
  [CORD_COLOR.ORANGE]: '#ff8500',
};

export const cordColorRules: {[key in CORD_COLOR]: string} = {
  [CORD_COLOR.BLACK]: '/EMB_ART_paire_force:/EMB_EPR_OPT_cordonEP2n:/',
  [CORD_COLOR.GREEN]: '/EMB_ART_paire_force:/EMB_EPR_OPT_cordonEP2v:/',
  [CORD_COLOR.BLUE]: '/EMB_ART_paire_force:/EMB_EPR_OPT_cordonEP2b:/',
  [CORD_COLOR.ORANGE]: '/EMB_ART_paire_force:/EMB_EPR_OPT_cordonEP2o:/',
};

export enum FILTER {
  DB_15 = 'DB_15',
  DB_25 = 'DB_25',
  DB_30 = 'DB_30',

  SNR22 = 'SNR22',
  SNR24 = 'SNR24',

  SNR21 = 'SNR21',
  SNR26 = 'SNR26',
}

export const filterLabels: {[key in FILTER]: string} = {
  [FILTER.DB_15]: '-15 dB',
  [FILTER.DB_25]: '-25 dB',
  [FILTER.DB_30]: '-30 dB',

  [FILTER.SNR22]: 'T3 (industries de production) SNR22',
  [FILTER.SNR24]: 'T4 (industries lourdes) SNR24',

  [FILTER.SNR21]: 'C2 (usage privé) SNR21',
  [FILTER.SNR26]: 'C3 (industrie de conditionnement) SNR26',
};

export const required = {required: true};
export const unique = {unique: true};
export const requiredAndUnique = {...required, ...unique};

export enum SURFACE {
  ANTIBACTERIAL = 'ANTIBACTERIAL',
  MATTE = 'MATTE',
  SANDED = 'SANDED',
}
export const surfaceLabels: {[key in SURFACE]: string} = {
  [SURFACE.ANTIBACTERIAL]: 'Vernis antibactérien',
  [SURFACE.MATTE]: 'Vernis mat',
  [SURFACE.SANDED]: 'Sablage',
};
export const surfaceRules: {[key in SURFACE]?: string} = {
  [SURFACE.ANTIBACTERIAL]: commonRules.antibacterialVarnish,
};

export enum OBTURATEUR_PRODUCT_TYPE {
  ANTI_NOISE = 'ANTI_NOISE',
  ANTI_WATER = 'ANTI_WATER',
}

export const obturateurProductTypeLabels: {
  [key in OBTURATEUR_PRODUCT_TYPE]: string;
} = {
  [OBTURATEUR_PRODUCT_TYPE.ANTI_NOISE]: 'Anti-Bruit',
  [OBTURATEUR_PRODUCT_TYPE.ANTI_WATER]: 'Anti-Eau',
};

export enum PASSTOR_OR_PRODUCT_TYPE {
  R1 = 'R1',
  R2 = 'R2',
  R3 = 'R3',
}

export enum FINISH {
  COMPLETE_SANDING = 'COMPLETE_SANDING',
  OUTSIDE_SANDING = 'OUTSIDE_SANDING',
  ANNALERGIC = 'ANNALERGIC',
  SHINY = 'SHINY',
  MATTE_SANDED = 'MATTE_SANDED',
  SANDED_OUTSIDE = 'SANDED_OUTSIDE',
  VARNISH = 'VARNISH',
  UV_VARNISH = 'UV_VARNISH',
  WITHOUT_VARNISH = 'WITHOUT_VARNISH',
}

export const finishLabels: {[key in FINISH]: string} = {
  [FINISH.COMPLETE_SANDING]: 'Sablage complet',
  [FINISH.OUTSIDE_SANDING]: 'Sablage extérieur',
  [FINISH.ANNALERGIC]: 'Traitement anallergique',
  [FINISH.SHINY]: 'Brillant',
  [FINISH.MATTE_SANDED]: 'Mat sablé',
  [FINISH.SANDED_OUTSIDE]: 'Sablé extérieur',
  [FINISH.VARNISH]: 'Vernis',
  [FINISH.UV_VARNISH]: 'Vernis UV',
  [FINISH.WITHOUT_VARNISH]: 'Sans vernis',
};

export const finishRules: {[key in FINISH]?: string} = {
  [FINISH.UV_VARNISH]: '/EMB_RES_OPT_vernis:/EMB_MCE_OPT_vernis:/',
};

export enum TYPE {
  PRODUCT_CATEGORY = 'category',
  DEPORTE_BRAND = 'deporteBrand',
  BRAND = 'brand',
  MATERIAL = 'material',
  COLOR = 'color',
  FILTER = 'filter',
  SURFACE = 'surface',
  EVENT = 'event',
  EVENT_TYPE_AND_SIZE = 'EVENT_TYPE_AND_SIZE',
  TUBE = 'tube',
  OPTION_TUBE = 'option_tube',
  SHOULDER = 'shoulder',
  COLOR_MARKER = 'color_marker',
  OTOSCAN = 'otoscan',
  EAR_BUD = 'ear_bud',
  EAR_BUD_ASSEMBLY = 'ear_bud_assembly',
  MISCELLANEOUS = 'miscellaneous',
  EARWAX_SHIELDING = 'earwax_shielding',
  FLOAT = 'float',
  CORD_COLOR = 'cord_color',
  OPTION = 'option',
  ENGRAVING = 'engraving',
  CAMO = 'CAMO',
  CORD = 'CORD',
  OBTURATEUR_PRODUCT_TYPE = 'OBTURATEUR_PRODUCT_TYPE',
  PASSTOP_OR_PRODUCT_TYPE = 'PASSTOP_OR_PRODUCT_TYPE',
  DEPORTE_OPTION = 'DEPORTE_OPTION',
  FINISH = 'FINISH',
  SHAPE = 'SHAPE',
  EARWAX_SHIELD = 'EARWAX_SHIELD',
}

export const getTypeLabel = (type: TYPE): string => {
  switch (type) {
    case TYPE.PRODUCT_CATEGORY:
      return 'Catégorie';
    case TYPE.DEPORTE_BRAND:
      return 'Marque';
    case TYPE.BRAND:
      return 'Marque';
    case TYPE.MATERIAL:
      return 'Matière';
    case TYPE.COLOR:
      return 'Couleur';
    case TYPE.FILTER:
      return 'Filtre';
    case TYPE.SURFACE:
      return 'Traitement de surface';
    case TYPE.EVENT:
      return 'Diamètre event';
    case TYPE.EVENT_TYPE_AND_SIZE:
      return 'Event (Type & Diamètre)';
    case TYPE.TUBE:
      return 'Tube';
    case TYPE.OPTION_TUBE:
      return 'Options Tube';
    case TYPE.SHOULDER:
      return 'Longueur épaulement';
    case TYPE.COLOR_MARKER:
      return 'Repère de couleur';
    case TYPE.OTOSCAN:
      return 'OTOSCAN Otometrics';
    case TYPE.EAR_BUD:
      return 'Écouteur';
    case TYPE.EAR_BUD_ASSEMBLY:
      return 'Montage Écouteur';
    case TYPE.MISCELLANEOUS:
      return 'Divers';
    case TYPE.EARWAX_SHIELDING:
      return 'Pare-cérumen';
    case TYPE.FLOAT:
      return 'Options';
    case TYPE.CORD_COLOR:
      return 'Cordon';
    case TYPE.OPTION:
    case TYPE.DEPORTE_OPTION:
      return 'Options';
    case TYPE.ENGRAVING:
      return 'Gravure';
    case TYPE.CAMO:
      return 'Option';
    case TYPE.CORD:
      return 'Cordon';
    case TYPE.PASSTOP_OR_PRODUCT_TYPE:
    case TYPE.OBTURATEUR_PRODUCT_TYPE:
      return 'Type de produit';
    case TYPE.FINISH:
      return 'Finition';
    case TYPE.SHAPE:
      return 'Forme';
    default:
      return '%MISSING_TYPE_LABEL%';
  }
};

export type Typed = {type?: TYPE};
export type Product = CLASSIQUE_SHAPE | DEPORTE_SHAPE | PROTECTION_SHAPE;
export type Shape = DEPORTE_SHAPE;
export type Material = CLASSIQUE_MATERIAL | DEPORTE_MATERIAL;

type CommonOption = {
  [key in Material | COLOR | FILTER]?: OptionDataContainer & Typed;
};

export const CommonOptionDataKeys: string[] = ['type', 'required', 'unique'];

export const BOOLEAN_VALUE = '__BOOLEAN_VALUE';
type BOOLEAN_VALUE_TYPE = typeof BOOLEAN_VALUE;

export interface OptionValueMap<T = string> {
  value: T;
  type?: OPTION_GROUP_CHECK_TYPE;
  radioGroup?: string;
  disabledCallback?: (
    selectedOptions: OptionInterface[],
    index: number,
  ) => boolean;
  alwaysSelected?: true;
  defaultSelected?: true;
  isPair?: true;
}

export interface OptionData<T = string> {
  required?: boolean;
  unique?: boolean;
  type: TYPE;
  values: (OptionValueMap<T> | T)[];
  valuesBrandCallback?: (brand: DEPORTE_BRAND) => T[];
}

export interface OptionDataContainer {
  options: OptionData[];
  required?: boolean;
  unique?: boolean;
}

export const materialLabels: {[key in Material]: string} = {
  [CLASSIQUE_MATERIAL.RESINE_3D]: 'Résine 3D',
  [CLASSIQUE_MATERIAL.PLATINUM_25_SH]: 'Platinium 25 sh',
  [CLASSIQUE_MATERIAL.PLATINUM_40_SH]: 'Platinium 40 sh',
  [CLASSIQUE_MATERIAL.PLATINUM_60_SH]: 'Platinium 60 sh',
  [DEPORTE_MATERIAL.RESINE_3D]: 'Résine 3D',
  [DEPORTE_MATERIAL.SILICON_PLATNIUM_40]: 'Silicone (platinium 40 sh)',
};

export const shapeLabels: {[key in Shape]: string} = {
  [DEPORTE_SHAPE.DEPORTE]: 'Embouts déportés',
  [DEPORTE_SHAPE.CANULE_AERO]: 'Canule Aéro',
  [DEPORTE_SHAPE.COQUE]: 'Coque',

  [DEPORTE_SHAPE.DEPORTE_CONDUIT]: 'Conduit',
  [DEPORTE_SHAPE.DEPORTE_PHANTOMOLD]: 'Phantomold',
  [DEPORTE_SHAPE.DEPORTE_COQUILLE]: 'Coquille',
  [DEPORTE_SHAPE.DEPORTE_HALF_CONQUE]: 'Demi-conque',
  [DEPORTE_SHAPE.DEPORTE_SILHOUETTE]: 'Silhouette',

  [DEPORTE_SHAPE.AERO_CANULE]: 'Canule',
  [DEPORTE_SHAPE.AERO_SKELETON]: 'Squelette',

  [DEPORTE_SHAPE.CRAB_CANULE]: 'Canule',
};

export const brandLabels: {[key in DEPORTE_BRAND]: string} = {
  [DEPORTE_BRAND.SIEMENS]: 'Siemens',
  [DEPORTE_BRAND.OTICON]: 'Oticon',
  [DEPORTE_BRAND.BELTONE]: 'Beltone',
  [DEPORTE_BRAND.WIDEX]: 'Widex',
  [DEPORTE_BRAND.PHONAK]: 'Phonak',
  [DEPORTE_BRAND.STARKEY]: 'Starkey',
};

type DeporteShape = {
  [key in DEPORTE_SHAPE]?: CommonOption & Typed;
};
export type ProductCategoryType = (
  | DeporteShape
  | CommonOption
  | OptionDataContainer
) &
  Typed;

export const isOptionData = (type: ProductCategoryType): type is OptionData =>
  !!(type as OptionData).values;

type ProductCategory = {
  [key in Product]?: ProductCategoryType;
};

export type OptionsTree = {
  [key in PRODUCT_CATEGORY]: ProductCategory & Typed;
};

export enum EVENT {
  D00_MM = 'D00_MM',
  D05_MM = 'D05_MM',
  D08_MM = 'D08_MM',
  D10_MM = 'D10_MM',
  D12_MM = 'D12_MM',
  D13_MM = 'D13_MM',
  D15_MM = 'D15_MM',
  D20_MM = 'D20_MM',
  D25_MM = 'D25_MM',
  D30_MM = 'D30_MM',
  MAX = 'MAX',
  SPIRAL = 'SPIRAL',
  PARALLEL = 'PARALLEL',
  Y_SHAPE = 'Y_SHAPE',
  GROOVED = 'GROOVED',
  POWER_VENT = 'POWER_VENT',
  CUSTOM = 'CUSTOM',
  NONE = 'NONE',
}
export const eventLabels: {[key in EVENT]: string} = {
  [EVENT.D00_MM]: '0 mm',
  [EVENT.D05_MM]: '0,5 mm',
  [EVENT.D08_MM]: '0,8 mm',
  [EVENT.D10_MM]: '1 mm',
  [EVENT.D12_MM]: '1,2 mm',
  [EVENT.D13_MM]: '1,3 mm',
  [EVENT.D15_MM]: '1,5 mm',
  [EVENT.D20_MM]: '2 mm',
  [EVENT.D25_MM]: '2,5 mm',
  [EVENT.D30_MM]: '3 mm',
  [EVENT.MAX]: 'Max',
  [EVENT.SPIRAL]: 'Spiralé',
  [EVENT.PARALLEL]: 'Parallèle',
  [EVENT.GROOVED]: 'Rainuré',
  [EVENT.Y_SHAPE]: 'En Y',
  [EVENT.CUSTOM]: 'Event à la demande',
  [EVENT.POWER_VENT]: 'Power vent',
  [EVENT.NONE]: 'Aucun',
};

export const eventRules: {[key in EVENT]?: string} = {
  [EVENT.D05_MM]: '/EMB_RES_DBC_05:/EMB_SIL_DBC_05:/EMB_MCE_DBC_05:/',
  [EVENT.D08_MM]: '/EMB_MCE_DBC_08:/EMB_RES_DBC_08:/EMB_SIL_DBC_08:/',
  [EVENT.D10_MM]: '/EMB_MCE_DBC_10:/EMB_RES_DBC_10:/EMB_SIL_DBC_10:/',
  [EVENT.D12_MM]: '/EMB_MCE_DBC_12:/EMB_RES_DBC_12:/EMB_SIL_DBC_12:/',
  [EVENT.D15_MM]: '/EMB_MCE_DBC_15:/EMB_RES_DBC_15:/EMB_SIL_DBC_15:/',
  [EVENT.D20_MM]: '/EMB_MCE_DBC_20:/EMB_RES_DBC_20:/EMB_SIL_DBC_20:/',
  [EVENT.D25_MM]: '/EMB_MCE_DBC_25:/EMB_RES_DBC_25:/EMB_SIL_DBC_25:/',
  [EVENT.D30_MM]: '/EMB_MCE_DBC_30:/EMB_RES_DBC_30:/EMB_SIL_DBC_30:/',
  [EVENT.MAX]: '/EMB_MCE_DBC_MX:/EMB_RES_DBC_MX:/EMB_SIL_DBC_MX:/',

  [EVENT.PARALLEL]:
    '/EMB_MCE_DBC_Event_paralelle:/EMB_RES_DBC_Event_paralelle:/EMB_SIL_DBC_Event_paralelle:/',
  [EVENT.SPIRAL]: '/EMB_MCE_DBC_Event_spirale:/EMB_RES_DBC_Event_spirale:/',
  [EVENT.GROOVED]:
    '/EMB_MCE_DBC_Event_rainure:/EMB_RES_DBC_Event_rainure:/EMB_SIL_DBC_Event_rainure:/',
  [EVENT.Y_SHAPE]:
    '/EMB_MCE_DBC_Event_y:/EMB_RES_DBC_Event_y:/EMB_SIL_DBC_Event_y:/',
  [EVENT.POWER_VENT]: '/EMB_MCE_DBC_Event_power:/EMB_RES_DBC_Event_power:/',
};

export enum TUBE {
  D25_MM = 'D25_MM',
  D30_MM = 'D30_MM',
  D33_MM = 'D33_MM',
  WATERPROOF = 'WATERPROOF',

  FLEXIBLE = 'FLEXIBLE',
  MAT = 'MAT',
  COLORED = 'COLORED',
  HYDROSTOP = 'HYDROSTOP',
  THICK = 'TICK',
  SQUARE_SHOULDER = 'SQUARE_SHOULDER',
  CHILD = 'CHILD',
  LIBBY_3 = 'LIBBY_3',
  LIBBY_4 = 'LIBBY_4',
  LOCK = 'LOCK',
  UNGLUED = 'UNGLUED',
}
export const tubeLabels: {[key in TUBE]: string} = {
  [TUBE.D25_MM]: 'Tube diamètre 2,5mm',
  [TUBE.D30_MM]: 'Tube diamètre 3 mm (standard)',
  [TUBE.D33_MM]: 'Tube diamètre 3,3 mm',
  [TUBE.WATERPROOF]: 'Tube anti-humidité',

  [TUBE.FLEXIBLE]: 'Souple',
  [TUBE.MAT]: 'Mat',
  [TUBE.COLORED]: 'Coloré',
  [TUBE.HYDROSTOP]: 'Hydrostop',
  [TUBE.THICK]: 'Epais',
  [TUBE.SQUARE_SHOULDER]: 'Coude équerre',
  [TUBE.CHILD]: 'Enfant',
  [TUBE.LIBBY_3]: 'Libby 3',
  [TUBE.LIBBY_4]: 'Libby 4',
  [TUBE.LOCK]: 'Lock',
  [TUBE.UNGLUED]: 'Non collé',
};

export const tubeRules: {[key in TUBE]: string | null} = {
  [TUBE.D25_MM]: 'TUB_tube25',
  [TUBE.D30_MM]: 'TUB_tube30',
  [TUBE.D33_MM]: 'TUB_tube33',
  [TUBE.WATERPROOF]: 'TUB_humide',

  [TUBE.FLEXIBLE]: '/EMB_SIL_TUB_souple:/EMB_RES_TUB_souple:/',
  [TUBE.MAT]: '/EMB_SIL_TUB_tam:/EMB_RES_TUB_tam:/',
  [TUBE.COLORED]: '/EMB_SIL_TUP_colore:/',
  [TUBE.HYDROSTOP]:
    '/EMB_MCE_autre:/EMB_RES_TUB_condensation:/EMB_SIL_TUB_condensation:/',
  [TUBE.THICK]: '/EMB_SIL_TUB_iaGrosDiam:/EMB_RES_TUB_iaGrosDiam:/',
  [TUBE.SQUARE_SHOULDER]: '/EMB_SIL_TUB_avecEq:/EMB_RES_TUB_avecEq:/',
  [TUBE.CHILD]: '/EMB_SIL_TUB_enfant:/EMB_RES_TUB_enfant:/',
  [TUBE.LIBBY_3]: '/EMB_RES_TUB_libbyTrois:/EMB_SIL_TUB_libbyTrois:/',
  [TUBE.LIBBY_4]: '/EMB_SIL_TUB_libbyQuatre:/EMB_RES_TUB_libbyQuatre:/',
  [TUBE.LOCK]: '/EMB_SIL_TUB_special:/',
  [TUBE.UNGLUED]: null,
};

export enum OPTION_TUBE {
  GUIDE = 'GUIDE',
  RIGHT_ANGLE = 'RIGHT_ANGLE',
  LOCK = 'LOCK',
}

export const optionTubeLabels: {[key in OPTION_TUBE]: string} = {
  [OPTION_TUBE.GUIDE]: 'Guide tube',
  [OPTION_TUBE.RIGHT_ANGLE]: 'Coude équerre angle droit',
  [OPTION_TUBE.LOCK]: 'Bague lock',
};
export const optionTubeRules: {[key in OPTION_TUBE]: string} = {
  [OPTION_TUBE.GUIDE]: 'OPT_guideTube',
  [OPTION_TUBE.RIGHT_ANGLE]: 'OPT_coudeEq',
  [OPTION_TUBE.LOCK]: 'OPT_bague',
};

export const TubeOptions: OptionData<TUBE> = {
  ...unique,
  type: TYPE.TUBE,
  values: [TUBE.D25_MM, TUBE.D30_MM, TUBE.D33_MM, TUBE.WATERPROOF],
};

export const OptionTubeOptions: OptionData<OPTION_TUBE> = {
  type: TYPE.OPTION_TUBE,
  values: [OPTION_TUBE.GUIDE, OPTION_TUBE.RIGHT_ANGLE, OPTION_TUBE.LOCK],
};

export enum SHOULDER {
  LONG = 'LONG',
  SHORT = 'SHORT',
}
export const shoulderLabels: {[key in SHOULDER]: string} = {
  [SHOULDER.LONG]: 'Épaulement long',
  [SHOULDER.SHORT]: 'Épaulement court',
};

export const ShoulderOptions: OptionData<SHOULDER> = {
  ...unique,
  type: TYPE.SHOULDER,
  values: [SHOULDER.LONG, SHOULDER.SHORT],
};

export const ColorMarkerOptions: OptionData<BOOLEAN_VALUE_TYPE> = {
  ...unique,
  type: TYPE.COLOR_MARKER,
  values: [BOOLEAN_VALUE],
};

export const OtoscanOptions: OptionData<BOOLEAN_VALUE_TYPE> = {
  ...unique,
  type: TYPE.OTOSCAN,
  values: [BOOLEAN_VALUE],
};

export enum EAR_BUD {
  S = 'S',
  M = 'M',
  P = 'P',
  /* SP = 'SP',
  MICRO = 'MICRO',
  SILK = 'SILK', */

  S_3 = 'S_3',
  M_3 = 'M_3',
  P_3 = 'P_3',
  MICRO_3 = 'MICRO_3',

  STANDARD = 'STANDARD',
  MEDIUM = 'MEDIUM',
  INTIGA = 'INTIGA',
  ALTA_60 = 'ALTA_60',
  ALTA_85 = 'ALTA_85',
  ALTA_100 = 'ALTA_100',
  RIC80 = 'RIC80',
  /* CORDA_SQUARED = 'CORDA_SQUARED',
  MINI_FIT_CORDA = 'MINI_FIT_CORDA', */

  LP_40DB = 'LP_40DB',
  MP_50DB = 'MP_50DB',
  HP_60DB = 'HP_60DB',

  C_LP_40DB = 'C_LP_40DB',
  C_MP_50DB = 'C_MP_50DB',
  C_HP_60DB = 'C_HP_60DB',

  SUREFIT_3_LP_40DB = 'SUREFIT_3_LP_40DB',
  SUREFIT_3_MP_50DB = 'SUREFIT_3_MP_50DB',
  SUREFIT_3_HP_60DB = 'SUREFIT_3_HP_60DB',
  SUREFIT_3_MRIE_MP = 'SUREFIT_3_MRIE_MP',

  BELTONE_S = 'BELTONE_S',
  HP2 = 'HP2',
  HPG = 'HPG',
  LP_NP = 'LP_NP',

  EASYWEAR_S = 'EASYWEAR_S',
  EASYWEAR_M = 'EASYWEAR_M',
  EASYWEAR_P = 'EASYWEAR_P',

  MOMENT_M = 'MOMENT_M',
  MOMENT_P = 'MOMENT_P',
  /* MICRO_TUBE_ELAN_13 = 'MICRO_TUBE_ELAN_13',
  MICRO_TUBE_M_10 = 'MICRO_TUBE_M_10',
  MICRO_TUBE_EASYWEAR_09_16 = 'MICRO_TUBE_EASYWEAR_09_16', */

  ECOUTEUR_XS = 'ECOUTEUR_XS',
  ECOUTEUR_XP = 'ECOUTEUR_XP',
  /* M_TUBE = 'M_TUBE', */
  ECOUTEUR_MARVEL_S = 'ECOUTEUR_MARVEL_S',
  ECOUTEUR_MARVEL_M = 'ECOUTEUR_MARVEL_M',
  ECOUTEUR_MARVEL_P = 'ECOUTEUR_MARVEL_P',
  STANDARD_45DB = 'STANDARD_45DB',
  POWER = 'POWER',
  /* CROS = 'CROS', */

  DB_40 = 'DB_40',
  DB_50 = 'DB_50',
  DB_60 = 'DB_60',
}
export const earBudLabels: {[key in EAR_BUD]: string} = {
  [EAR_BUD.S]: 'S',
  [EAR_BUD.M]: 'M',
  [EAR_BUD.P]: 'P',

  [EAR_BUD.S_3]: 'S 3.0',
  [EAR_BUD.M_3]: 'M 3.0',
  [EAR_BUD.P_3]: 'P 3.0',
  [EAR_BUD.MICRO_3]: 'µ tube 3.0',

  [EAR_BUD.STANDARD]: 'Standard',
  [EAR_BUD.MEDIUM]: 'Medium',
  [EAR_BUD.INTIGA]: 'Intiga',
  [EAR_BUD.ALTA_60]: 'Alta 60',
  [EAR_BUD.ALTA_85]: 'Alta 85',
  [EAR_BUD.ALTA_100]: 'Alta 100',
  [EAR_BUD.RIC80]: 'Design RIC80',

  [EAR_BUD.LP_40DB]: 'Surefit 2 LP - 40dB',
  [EAR_BUD.MP_50DB]: 'Surefit 2 MP - 50dB',
  [EAR_BUD.HP_60DB]: 'Surefit 2 HP - 60dB',

  [EAR_BUD.C_LP_40DB]: 'Surefit 2 C LP - 40dB',
  [EAR_BUD.C_MP_50DB]: 'Surefit 2 C MP - 50dB',
  [EAR_BUD.C_HP_60DB]: 'Surefit 2 C HP - 60dB',

  [EAR_BUD.SUREFIT_3_LP_40DB]: 'Surefit 3 LP - 40dB',
  [EAR_BUD.SUREFIT_3_MP_50DB]: 'Surefit 3 MP - 50dB',
  [EAR_BUD.SUREFIT_3_HP_60DB]: 'Surefit 3 HP - 60dB',
  [EAR_BUD.SUREFIT_3_MRIE_MP]: 'Surefit 3 M&RIE - MP',

  [EAR_BUD.BELTONE_S]: 'S',
  [EAR_BUD.HP2]: 'HP2',
  [EAR_BUD.HPG]: 'HPG ancienne génération',
  [EAR_BUD.LP_NP]: 'LP/NP ancienne génération',

  [EAR_BUD.EASYWEAR_S]: 'Easywear S',
  [EAR_BUD.EASYWEAR_M]: 'Easywear M',
  [EAR_BUD.EASYWEAR_P]: 'Easywear P',

  [EAR_BUD.MOMENT_M]: 'Moment M',
  [EAR_BUD.MOMENT_P]: 'Moment P',

  [EAR_BUD.ECOUTEUR_XS]: 'Ecouteur XS',
  [EAR_BUD.ECOUTEUR_XP]: 'Ecouteur XP',
  [EAR_BUD.ECOUTEUR_MARVEL_S]: 'Ecouteur Marvel S',
  [EAR_BUD.ECOUTEUR_MARVEL_M]: 'Ecouteur Marvel M',
  [EAR_BUD.ECOUTEUR_MARVEL_P]: 'Ecouteur Marvel P',
  [EAR_BUD.STANDARD_45DB]: 'Standard 45dB ancienne génération',
  [EAR_BUD.POWER]: 'Power ancienne génération',

  [EAR_BUD.DB_40]: 'Ecouteur 40 dB',
  [EAR_BUD.DB_50]: 'Ecouteur 50 dB',
  [EAR_BUD.DB_60]: 'Ecouteur 60 dB',
};

export const SiemensEarBudOptions: EAR_BUD[] = [
  EAR_BUD.S,
  EAR_BUD.M,
  EAR_BUD.P,

  EAR_BUD.S_3,
  EAR_BUD.M_3,
  EAR_BUD.P_3,
  EAR_BUD.MICRO_3,
];

export const OticonEarBudOptions: EAR_BUD[] = [
  EAR_BUD.STANDARD,
  EAR_BUD.MEDIUM,
  EAR_BUD.INTIGA,
  EAR_BUD.ALTA_60,
  EAR_BUD.ALTA_85,
  EAR_BUD.ALTA_100,
  EAR_BUD.RIC80,
];

export const BeltoneEarBudOptions: EAR_BUD[] = [
  EAR_BUD.LP_40DB,
  EAR_BUD.MP_50DB,
  EAR_BUD.HP_60DB,
  EAR_BUD.C_LP_40DB,
  EAR_BUD.C_MP_50DB,
  EAR_BUD.C_HP_60DB,
  EAR_BUD.BELTONE_S,
  EAR_BUD.SUREFIT_3_LP_40DB,
  EAR_BUD.SUREFIT_3_MP_50DB,
  EAR_BUD.SUREFIT_3_HP_60DB,
  EAR_BUD.SUREFIT_3_MRIE_MP,
  EAR_BUD.HP2,
  EAR_BUD.HPG,
  EAR_BUD.LP_NP,
];

export const WidexEarBudOptions: EAR_BUD[] = [
  EAR_BUD.MOMENT_M,
  EAR_BUD.MOMENT_P,

  EAR_BUD.EASYWEAR_S,
  EAR_BUD.EASYWEAR_M,
  EAR_BUD.EASYWEAR_P,
];

export const PhonakEarBudOptions: EAR_BUD[] = [
  EAR_BUD.ECOUTEUR_XS,
  EAR_BUD.ECOUTEUR_XP,
  EAR_BUD.ECOUTEUR_MARVEL_S,
  EAR_BUD.ECOUTEUR_MARVEL_M,
  EAR_BUD.ECOUTEUR_MARVEL_P,
  EAR_BUD.STANDARD_45DB,
  EAR_BUD.POWER,
];

export const StarkeyEarBudOptions: EAR_BUD[] = [
  EAR_BUD.DB_40,
  EAR_BUD.DB_50,
  EAR_BUD.DB_60,
];

export const brandEarBudMap: {[brand in DEPORTE_BRAND]: EAR_BUD[]} = {
  [DEPORTE_BRAND.SIEMENS]: SiemensEarBudOptions,
  [DEPORTE_BRAND.OTICON]: OticonEarBudOptions,
  [DEPORTE_BRAND.BELTONE]: BeltoneEarBudOptions,
  [DEPORTE_BRAND.WIDEX]: WidexEarBudOptions,
  [DEPORTE_BRAND.PHONAK]: PhonakEarBudOptions,
  [DEPORTE_BRAND.STARKEY]: StarkeyEarBudOptions,
};

export enum EARWAX_SHIELD {
  SIGNIA_RING = 'SIGNIA_RING',
  VALVE = 'VALVE',
  LONG_SIGNIA = 'LONG_SIGNIA',

  ASSEMBLED = 'ASSEMBLED',
  MARVEL_RING = 'MARVEL_RING',
  LONG_PHONAK = 'LONG_PHONAK',

  ORIGINAL = 'ORIGINAL',

  LOCKED = 'LOCKED',
}

export const earWaxShieldLabels: {[key in EARWAX_SHIELD]: string} = {
  [EARWAX_SHIELD.SIGNIA_RING]: 'Bague Signia + pare cérumen quickgard',
  [EARWAX_SHIELD.VALVE]: 'Pare cérumen à clapet',
  [EARWAX_SHIELD.LONG_SIGNIA]: 'Version longue Signia (Bague + C-grid)',
  [EARWAX_SHIELD.ASSEMBLED]: 'Montage tube',
  [EARWAX_SHIELD.MARVEL_RING]: 'Bague Phonak Marvel',
  [EARWAX_SHIELD.LONG_PHONAK]:
    'Version longue Phonak (Plasting Bushing + Cérustop)',
  [EARWAX_SHIELD.ORIGINAL]: "Bague d'origine",
  [EARWAX_SHIELD.LOCKED]: 'Bague vérouil. Widex',
};

export const earWaxShieldRules: {[key in EARWAX_SHIELD]: string} = {
  [EARWAX_SHIELD.SIGNIA_RING]: '/EMB_MCE_PAR_signiaHF:/',
  [EARWAX_SHIELD.VALVE]: '/EMB_MCE_PAR_clapet:/EMB_RES_autre:/',
  [EARWAX_SHIELD.LONG_SIGNIA]: '/EMB_MCE_PAR_signia:/',
  [EARWAX_SHIELD.ASSEMBLED]: '/EMB_MCE_PAR_tube:/',
  [EARWAX_SHIELD.MARVEL_RING]: '/EMB_MCE_PAR_phonak:/',
  [EARWAX_SHIELD.LONG_PHONAK]: '/EMB_MCE_PAR_longuePhonak:/',
  [EARWAX_SHIELD.ORIGINAL]: '/EMB_MCE_PAR_origine:/',
  [EARWAX_SHIELD.LOCKED]: '/EMB_MCE_PAR_widex:/',
};

const siliconDisabledCallback = (
  options: OptionInterface[],
  index: number,
): boolean =>
  !!options
    .filter(({name}) =>
      [DEPORTE_MATERIAL.SILICON_PLATNIUM_40].includes(name as DEPORTE_MATERIAL),
    )
    .find(({selected}) => selected[index]);

const getSiemensDisabledCallback = (shield: EARWAX_SHIELD) => (
  options: OptionInterface[],
  index: number,
): boolean => {
  const hasTube3 = !!options
    .filter(({name}) =>
      [EAR_BUD.P_3, EAR_BUD.M_3, EAR_BUD.S_3, EAR_BUD.MICRO_3].includes(
        name as EAR_BUD,
      ),
    )
    .find(({selected}) => selected[index]);

  if (
    hasTube3 &&
    [
      EARWAX_SHIELD.SIGNIA_RING,
      EARWAX_SHIELD.VALVE,
      EARWAX_SHIELD.LONG_SIGNIA,
    ].includes(shield)
  ) {
    return true;
  }

  const hasTube1 = !!options
    .filter(({name}) =>
      [EAR_BUD.P, EAR_BUD.M, EAR_BUD.S].includes(name as EAR_BUD),
    )
    .find(({selected}) => selected[index]);

  if (hasTube1 && [EARWAX_SHIELD.ORIGINAL].includes(shield)) {
    return true;
  }

  return siliconDisabledCallback(options, index);
};

export const SiemensEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  EARWAX_SHIELD.ORIGINAL,
  EARWAX_SHIELD.SIGNIA_RING,
  EARWAX_SHIELD.VALVE,
  EARWAX_SHIELD.LONG_SIGNIA,
].map((value) => ({
  value,
  disabledCallback: getSiemensDisabledCallback(value),
}));

export const OticonEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  EARWAX_SHIELD.ASSEMBLED,
  EARWAX_SHIELD.ORIGINAL,
].map((value) => ({value, disabledCallback: siliconDisabledCallback}));

export const BeltoneEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  EARWAX_SHIELD.ASSEMBLED,
  EARWAX_SHIELD.ORIGINAL,
].map((value) => ({value, disabledCallback: siliconDisabledCallback}));

export const WidexEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  EARWAX_SHIELD.ASSEMBLED,
  EARWAX_SHIELD.LOCKED,
].map((value) => ({value, disabledCallback: siliconDisabledCallback}));

export const PhonakEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  {
    value: EARWAX_SHIELD.ASSEMBLED,
    alwaysSelected: true,
    disabledCallback: (options, index) =>
      !options
        .filter(({name}) =>
          [
            EAR_BUD.ECOUTEUR_XS,
            EAR_BUD.ECOUTEUR_XP,
            EAR_BUD.STANDARD_45DB,
            EAR_BUD.POWER,
          ].includes(name as EAR_BUD),
        )
        .find(({selected}) => selected[index]) &&
      !!options
        .filter(({name}) =>
          [DEPORTE_MATERIAL.SILICON_PLATNIUM_40].includes(
            name as DEPORTE_MATERIAL,
          ),
        )
        .find(({selected}) => selected[index]),
  },
  ...[EARWAX_SHIELD.MARVEL_RING, EARWAX_SHIELD.LONG_PHONAK].map<
    OptionValueMap<EARWAX_SHIELD>
  >((value) => ({
    value,
    disabledCallback: (options, index) =>
      !options
        .filter(({name}) =>
          [
            EAR_BUD.ECOUTEUR_MARVEL_S,
            EAR_BUD.ECOUTEUR_MARVEL_M,
            EAR_BUD.ECOUTEUR_MARVEL_P,
          ].includes(name as EAR_BUD),
        )
        .find(({selected}) => selected[index]) &&
      !!options
        .filter(({name}) =>
          [DEPORTE_MATERIAL.SILICON_PLATNIUM_40].includes(
            name as DEPORTE_MATERIAL,
          ),
        )
        .find(({selected}) => selected[index]),
  })),
];

export const StarkeyEarWaxShieldOptions: OptionValueMap<EARWAX_SHIELD>[] = [
  {
    value: EARWAX_SHIELD.ASSEMBLED,
    alwaysSelected: true,
    disabledCallback: siliconDisabledCallback,
  },
];

export const brandEarWaxShieldMap: {
  [brand in DEPORTE_BRAND]: (EARWAX_SHIELD | OptionValueMap<EARWAX_SHIELD>)[];
} = {
  [DEPORTE_BRAND.SIEMENS]: SiemensEarWaxShieldOptions,
  [DEPORTE_BRAND.OTICON]: OticonEarWaxShieldOptions,
  [DEPORTE_BRAND.BELTONE]: BeltoneEarWaxShieldOptions,
  [DEPORTE_BRAND.WIDEX]: WidexEarWaxShieldOptions,
  [DEPORTE_BRAND.PHONAK]: PhonakEarWaxShieldOptions,
  [DEPORTE_BRAND.STARKEY]: StarkeyEarWaxShieldOptions,
};

export enum MISCELLANEOUS {
  COLOR_MARKER = 'COLOR_MARKER',
  EXTRACTION_CORDS = 'EXTRACTION_CORDS',
  GROOVED_EVENT = 'GROOVED_EVENT',
  ANTIBACTERIAL_VARNISH = 'ANTIBACTERIAL_VARNISH',
  SANDING = 'SANDING',
}
export const miscellaneousLabels: {[key in MISCELLANEOUS]: string} = {
  [MISCELLANEOUS.COLOR_MARKER]: 'Repère de couleur',
  [MISCELLANEOUS.EXTRACTION_CORDS]: "Fils d'extraction",
  [MISCELLANEOUS.GROOVED_EVENT]: 'Event rainuré',
  [MISCELLANEOUS.ANTIBACTERIAL_VARNISH]: 'Vernis antibactérien',
  [MISCELLANEOUS.SANDING]: 'Sablage',
};
export const miscellaneousRules: {[key in MISCELLANEOUS]?: string} = {
  [MISCELLANEOUS.EXTRACTION_CORDS]: 'OPT_fil',
  [MISCELLANEOUS.GROOVED_EVENT]: commonRules.groovedBlowhole,
  [MISCELLANEOUS.ANTIBACTERIAL_VARNISH]: commonRules.antibacterialVarnish,
};

export const MiscellaneousOptions: OptionData<MISCELLANEOUS> = {
  type: TYPE.MISCELLANEOUS,
  values: [
    MISCELLANEOUS.COLOR_MARKER,
    MISCELLANEOUS.EXTRACTION_CORDS,
    MISCELLANEOUS.GROOVED_EVENT,
  ],
};

export const EarBudAssemblyOptions: OptionData<BOOLEAN_VALUE_TYPE> = {
  ...unique,
  type: TYPE.EAR_BUD_ASSEMBLY,
  values: [BOOLEAN_VALUE],
};

export enum OPTION {
  CLIP = 'CLIP',
  HYGIENE = 'HYGIENE',

  CORD = 'CORD',
  EAR_BUD_WHITE = 'EAR_BUD_WHITE',
  EAR_BUD_BLACK = 'EAR_BUD_BLACK',
  EAR_BUD_SWITCH = 'EAR_BUD_SWITCH',

  MAGNETIC = 'MAGNETIC',
  COLOR_BLUE = 'COLOR_BLUE',
  HANDLE = 'HANDLE',

  LINK_CORD = 'LINK_CORD',
  PINK_SPARKLES = 'PINK_SPARKLES',
  BLUE_SPARKLES = 'BLUE_SPARKLES',

  SPARKLES = 'SPARKLES',

  CONQUE = 'CONQUE',
  METAL_DETECTION = 'METAL_DETECTION',

  CLOTHES_PIN = 'CLOTHES_PIN',

  IROS = 'IROS',
  HALF_IROS = 'HALF_IROS',
  TUBE_GUIDE = 'TUBE_GUIDE',
  COMPRESSIBLE_CONDUIT = 'COMPRESSIBLE_CONDUIT',
  EXTRACTION_CORD = 'EXTRACTION_CORD',
  DRILLED_MICROTUBE = 'DRILLED_MICROTUBE',

  FLOAT = 'FLOAT',
  CORD_MARK = 'CORD_MARK',
}

export const optionLabels: {[key in OPTION]: string} = {
  [OPTION.CLIP]: 'Clip de sécurité',
  [OPTION.HYGIENE]: 'Kit hygiène',

  [OPTION.CORD]: 'Cordon',
  [OPTION.EAR_BUD_WHITE]: 'Ecouteur (coloris blanc)',
  [OPTION.EAR_BUD_BLACK]: 'Ecouteur (coloris noir)',
  [OPTION.EAR_BUD_SWITCH]: 'Ecouteur Switch (main libre)',

  [OPTION.MAGNETIC]: 'Détection magnétique',
  [OPTION.COLOR_BLUE]: 'Couleur bleu alimentaire',
  [OPTION.HANDLE]: 'Poignée de préhension',

  [OPTION.LINK_CORD]: 'Cordon de liaison',
  [OPTION.PINK_SPARKLES]: 'Paillettes roses',
  [OPTION.BLUE_SPARKLES]: 'Paillettes bleues',

  [OPTION.SPARKLES]: 'Paillettes',

  [OPTION.CONQUE]: 'Conque',
  [OPTION.METAL_DETECTION]: 'Détection métallique',

  [OPTION.CLOTHES_PIN]: 'Pince vêtement',

  [OPTION.IROS]: 'Iros',
  [OPTION.HALF_IROS]: '1/2 Iros – 1/2 custom – 1/2 plateau',
  [OPTION.TUBE_GUIDE]: 'Guide tube',
  [OPTION.COMPRESSIBLE_CONDUIT]: 'Conduit Compressible',
  [OPTION.EXTRACTION_CORD]: "Fil d'extraction",
  [OPTION.DRILLED_MICROTUBE]: 'Perçage micro-tube',

  [OPTION.FLOAT]: 'Flotteur (indisponible)',
  [OPTION.CORD_MARK]: 'Gravage sur plaque de cordon',
};

export const optionRules: {[key in OPTION]?: string} = {
  [OPTION.CLIP]: 'OPT_option07',
  [OPTION.HYGIENE]: 'OPT_option08',

  [OPTION.MAGNETIC]: 'OPT_option13',
  [OPTION.COLOR_BLUE]: 'OPT_option14',
  [OPTION.HANDLE]: 'OPT_option15',

  [OPTION.SPARKLES]: 'OPT_option16',
  [OPTION.PINK_SPARKLES]: 'OPT_option16',
  [OPTION.BLUE_SPARKLES]: 'OPT_option16',
  [OPTION.LINK_CORD]: 'OPT_aquastopC',

  [OPTION.CORD]:
    '/EMB_ART_paire_force:/EMB_EPR_OPT_Cordon:/EMB_EPR_EBT_autre:/',
  [OPTION.CLOTHES_PIN]: '/EMB_ART_paire_force:/EMB_EPR_OPT_pince:/',

  [OPTION.CONQUE]: '/EMB_EPR_EBT_OPR_Conque:/',
  [OPTION.METAL_DETECTION]: '/EMB_EPR_EBT_OPT_Detection:/',

  [OPTION.IROS]: '/EMB_MCE_autre:/EMB_SIL_OPT_iros:/EMB_RES_OPT_iros:/',
  [OPTION.HALF_IROS]: '/EMB_SIL_OPT_demiIros:/EMB_RES_OPT_demiIros:/',
  [OPTION.COMPRESSIBLE_CONDUIT]: '/EMB_SIL_OPT_conduitComp:/',
  // TODO comment color
  [OPTION.TUBE_GUIDE]: '/EMB_SIL_OPT_guideTube:/EMB_RES_OPT_guideTube:/',
  [OPTION.EXTRACTION_CORD]: '/EMB_RES_autre:/',

  [OPTION.FLOAT]: '/EMB_EPR_EBT_OPT_Flotteur:/',
  [OPTION.CORD_MARK]: '/EMB_ART_paire_force:/EMB_EPR_EBT_OPT_Gravage:/',
};

export const optionEmboutLabelRules: {[key in OPTION]?: string} = {
  [OPTION.DRILLED_MICROTUBE]: 'percage',
  [OPTION.TUBE_GUIDE]: 'guideTube',
  [OPTION.EXTRACTION_CORD]: 'filExtraction',
  [OPTION.COMPRESSIBLE_CONDUIT]: 'conduitCompressible',
};

export enum DEPORTE_OPTION {
  SHORT_EPAULEMENT = 'SHORT_EPAULEMENT',
  LONG_EPAULEMENT = 'LONG_EPAULEMENT',
  FULL = 'FULL',
  HOLLOW = 'HOLLOW',
  LEFT_RIGHT_MARK = 'LEFT_RIGHT_MARK',
  CUSTOM_MARK = 'CUSTOM_MARK',
  EXTRACTION_CORD = 'EXTRACTION_CORD',
}

export const deporteOptionLabels: {[key in DEPORTE_OPTION]: string} = {
  [DEPORTE_OPTION.SHORT_EPAULEMENT]: 'Epaulement court',
  [DEPORTE_OPTION.LONG_EPAULEMENT]: 'Epaulement long',
  [DEPORTE_OPTION.FULL]: 'Embout plein',
  [DEPORTE_OPTION.HOLLOW]: 'Embout creux',
  [DEPORTE_OPTION.LEFT_RIGHT_MARK]: 'Marquage Droite et Gauche',
  [DEPORTE_OPTION.CUSTOM_MARK]: 'Autre marquage',
  [DEPORTE_OPTION.EXTRACTION_CORD]: "Fil d'extraction",
};

export const deporteOptionsTypeEmbout: {[key in DEPORTE_OPTION]?: string} = {
  [DEPORTE_OPTION.FULL]: 'plein',
  [DEPORTE_OPTION.HOLLOW]: 'creux',
};

export const deporteOptionsRules: {[key in DEPORTE_OPTION]?: string} = {
  [DEPORTE_OPTION.SHORT_EPAULEMENT]:
    '/EMB_MCE_OPT_epauleCourt:/EMB_RES_autre:/',
  [DEPORTE_OPTION.LONG_EPAULEMENT]: '/EMB_MCE_OPT_epauleLong:/EMB_RES_autre:/',
  // [DEPORTE_OPTION.FULL]: "label",
  // [DEPORTE_OPTION.HOLLOW]: "label",
  [DEPORTE_OPTION.LEFT_RIGHT_MARK]: '/EMB_MCE_OPT_marquageDG:/',
  [DEPORTE_OPTION.CUSTOM_MARK]: '/EMB_MCE_OPT_marquageDG:/',
  [DEPORTE_OPTION.EXTRACTION_CORD]: '/EMB_MCE_OPT_fil:/',
};

export const OptionOptions: OptionData<OPTION> = {
  ...unique,
  type: TYPE.OPTION,
  values: [OPTION.CLIP /*, OPTION.HYGIENE*/],
};

export const PasStopOptions: OptionData<OPTION> = {
  type: TYPE.OPTION,
  values: [OPTION.MAGNETIC, OPTION.COLOR_BLUE, OPTION.HANDLE],
};

export const ObturateurOptions: OptionData<OPTION> = {
  type: TYPE.OPTION,
  values: [OPTION.MAGNETIC, OPTION.LINK_CORD, OPTION.SPARKLES],
};

export const CamoOptions: OptionData<BOOLEAN_VALUE_TYPE> = {
  ...unique,
  type: TYPE.CAMO,
  values: [BOOLEAN_VALUE],
};

const eventSizeOptions = {
  ...requiredAndUnique,
  type: TYPE.EVENT,
  values: [
    EVENT.D05_MM,
    EVENT.D08_MM,
    EVENT.D10_MM,
    EVENT.D12_MM,
    EVENT.D15_MM,
    EVENT.D20_MM,
    EVENT.D25_MM,
    EVENT.D30_MM,
    EVENT.MAX,
    EVENT.CUSTOM,
  ],
};

const finishOptions: OptionValueMap<FINISH>[] = [
  ...[FINISH.COMPLETE_SANDING, FINISH.SANDED_OUTSIDE].map<
    OptionValueMap<FINISH>
  >((value) => ({
    value,
    disabledCallback: (options, index) =>
      !(
        options
          .filter(({name}) =>
            [DEPORTE_MATERIAL.RESINE_3D].includes(name as DEPORTE_MATERIAL),
          )
          .find(({selected}) => selected[index]) ||
        options
          .filter(({name}) =>
            [DEPORTE_SHAPE.DEPORTE_SILHOUETTE].includes(name as DEPORTE_SHAPE),
          )
          .find(({selected}) => selected[index])
      ),
  })),
  ...[FINISH.VARNISH].map<OptionValueMap<FINISH>>((value) => ({
    value,
    disabledCallback: (options, index) =>
      !options
        .filter(({name}) =>
          [DEPORTE_MATERIAL.SILICON_PLATNIUM_40].includes(
            name as DEPORTE_MATERIAL,
          ),
        )
        .find(({selected}) => selected[index]) ||
      !!options
        .filter(({name}) =>
          [DEPORTE_SHAPE.DEPORTE_SILHOUETTE].includes(name as DEPORTE_SHAPE),
        )
        .find(({selected}) => selected[index]),
  })),
  ...[FINISH.UV_VARNISH].map<OptionValueMap<FINISH>>((value) => ({
    value,
    disabledCallback: (options, index) =>
      !(
        options
          .filter(({name}) =>
            [DEPORTE_MATERIAL.RESINE_3D].includes(name as DEPORTE_MATERIAL),
          )
          .find(({selected}) => selected[index]) ||
        options
          .filter(({name}) =>
            [DEPORTE_SHAPE.DEPORTE_SILHOUETTE].includes(name as DEPORTE_SHAPE),
          )
          .find(({selected}) => selected[index])
      ),
  })),
  ...[FINISH.ANNALERGIC, FINISH.WITHOUT_VARNISH].map<OptionValueMap<FINISH>>(
    (value) => ({
      value,
    }),
  ),
];

const allFinishOptions = {
  ...requiredAndUnique,
  type: TYPE.FINISH,
  values: finishOptions,
};

const drilledMicrotubeDisabledCallback = (
  options: OptionInterface[],
  index: number,
): boolean =>
  !!options
    .filter(({name}) => [OPTION.DRILLED_MICROTUBE].includes(name as OPTION))
    .find(({selected}) => selected[index]);

const getClassiqueOptions = (shape: CLASSIQUE_SHAPE): OptionData[] => [
  {
    ...requiredAndUnique,
    type: TYPE.MATERIAL,
    values: [
      CLASSIQUE_MATERIAL.RESINE_3D,
      ...(shape !== CLASSIQUE_SHAPE.PINCE_CRABE
        ? [CLASSIQUE_MATERIAL.PLATINUM_25_SH]
        : []),
      CLASSIQUE_MATERIAL.PLATINUM_40_SH,
      CLASSIQUE_MATERIAL.PLATINUM_60_SH,
    ],
  },
  {
    ...requiredAndUnique,
    type: TYPE.COLOR,
    values: [
      COLOR.COLORLESS_TRANSLUCENT,
      COLOR.ROSE_TRANSLUCENT,
      {
        value: COLOR.BROWN,
        disabledCallback: (options, index) =>
          !!options
            .filter(({name}) =>
              [CLASSIQUE_MATERIAL.PLATINUM_25_SH].includes(
                name as CLASSIQUE_MATERIAL,
              ),
            )
            .find(({selected}) => selected[index]),
      },
    ],
  },
  {
    ...unique,
    type: TYPE.OPTION,
    values: [
      {
        value: OPTION.IROS,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        disabledCallback: () => shape === CLASSIQUE_SHAPE.CONDUIT,
      },
      {
        value: OPTION.HALF_IROS,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        disabledCallback: () => shape === CLASSIQUE_SHAPE.CONDUIT,
      },
      {value: OPTION.TUBE_GUIDE, type: OPTION_GROUP_CHECK_TYPE.CHECKBOX},
      /* {
        value: OPTION.COMPRESSIBLE_CONDUIT,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [
                CLASSIQUE_MATERIAL.PLATINUM_40_SH,
                CLASSIQUE_MATERIAL.PLATINUM_60_SH,
              ].includes(name as CLASSIQUE_MATERIAL),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: OPTION.DRILLED_MICROTUBE,
        type: OPTION_GROUP_CHECK_TYPE.CHECKBOX,
      },
      {
        value: OPTION.EXTRACTION_CORD,
        type: OPTION_GROUP_CHECK_TYPE.CHECKBOX,
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [CLASSIQUE_MATERIAL.RESINE_3D].includes(
                name as CLASSIQUE_MATERIAL,
              ),
            )
            .find(({selected}) => selected[index]),
      }, */
    ],
  },
  {
    ...requiredAndUnique,
    type: TYPE.TUBE,
    values: [
      ...[
        TUBE.FLEXIBLE,
        TUBE.MAT,
        TUBE.HYDROSTOP,
        TUBE.THICK,
        TUBE.SQUARE_SHOULDER,
        TUBE.CHILD,
        TUBE.LIBBY_3,
        TUBE.LIBBY_4,
      ].map((value) => ({
        value,
        // disabledCallback: drilledMicrotubeDisabledCallback,
      })),
      {
        value: TUBE.LOCK,
        disabledCallback: (options, index) =>
          drilledMicrotubeDisabledCallback(options, index) ||
          !options
            .filter(({name}) =>
              [
                CLASSIQUE_MATERIAL.PLATINUM_25_SH,
                CLASSIQUE_MATERIAL.PLATINUM_40_SH,
                CLASSIQUE_MATERIAL.PLATINUM_60_SH,
              ].includes(name as CLASSIQUE_MATERIAL),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: TUBE.UNGLUED,
      },
    ],
  },
  {
    ...requiredAndUnique,
    type: TYPE.EVENT_TYPE_AND_SIZE,
    values: [
      {
        value: EVENT.PARALLEL,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'type',
      },
      {
        value: EVENT.SPIRAL,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'type',
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [CLASSIQUE_MATERIAL.RESINE_3D].includes(
                name as CLASSIQUE_MATERIAL,
              ),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: EVENT.GROOVED,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'type',
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [CLASSIQUE_MATERIAL.RESINE_3D].includes(
                name as CLASSIQUE_MATERIAL,
              ),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: EVENT.Y_SHAPE,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'type',
      },
      ...[EVENT.D05_MM, EVENT.D08_MM].map<OptionValueMap>((value) => ({
        value,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'size',
        disabledCallback: (options, index) =>
          !!options
            .filter(({name}) =>
              [EVENT.POWER_VENT, EVENT.NONE, EVENT.GROOVED].includes(
                name as EVENT,
              ),
            )
            .find(({selected}) => selected[index]),
      })),
      ...[
        EVENT.D10_MM,
        EVENT.D12_MM,
        EVENT.D15_MM,
        EVENT.D20_MM,
        EVENT.D25_MM,
        EVENT.D30_MM,
        EVENT.MAX,
      ].map<OptionValueMap>((value) => ({
        value,
        type: OPTION_GROUP_CHECK_TYPE.RADIO,
        radioGroup: 'size',
        disabledCallback: (options, index) =>
          !!options
            .filter(({name}) => [EVENT.NONE].includes(name as EVENT))
            .find(({selected}) => selected[index]),
      })),
      {
        value: EVENT.CUSTOM,
        type: OPTION_GROUP_CHECK_TYPE.EVENT_INPUT,
        radioGroup: 'size',
        disabledCallback: (options, index) =>
          !!options
            .filter(({name}) => [EVENT.NONE].includes(name as EVENT))
            .find(({selected}) => selected[index]),
      },
    ],
  },
  {
    ...requiredAndUnique,
    type: TYPE.FINISH,
    values: [
      ...[FINISH.COMPLETE_SANDING, FINISH.OUTSIDE_SANDING].map<OptionValueMap>(
        (value) => ({
          value,
          disabledCallback: (options, index) =>
            !options
              .filter(({name}) =>
                [CLASSIQUE_MATERIAL.RESINE_3D].includes(
                  name as CLASSIQUE_MATERIAL,
                ),
              )
              .find(({selected}) => selected[index]),
        }),
      ),
      {
        value: FINISH.ANNALERGIC,
      },
      {
        value: FINISH.VARNISH,
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [
                CLASSIQUE_MATERIAL.PLATINUM_25_SH,
                CLASSIQUE_MATERIAL.PLATINUM_40_SH,
                CLASSIQUE_MATERIAL.PLATINUM_60_SH,
              ].includes(name as CLASSIQUE_MATERIAL),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: FINISH.UV_VARNISH,
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [CLASSIQUE_MATERIAL.RESINE_3D].includes(
                name as CLASSIQUE_MATERIAL,
              ),
            )
            .find(({selected}) => selected[index]),
      },
      {
        value: FINISH.WITHOUT_VARNISH,
      },
    ],
  },
];

const getDeporteOptions = (shape: DEPORTE_SHAPE): OptionData[] => [
  {
    ...requiredAndUnique,
    type: TYPE.SHAPE,
    values: [
      DEPORTE_SHAPE.DEPORTE_CONDUIT,
      DEPORTE_SHAPE.DEPORTE_PHANTOMOLD,
      DEPORTE_SHAPE.DEPORTE_COQUILLE,
      DEPORTE_SHAPE.DEPORTE_HALF_CONQUE,
      DEPORTE_SHAPE.DEPORTE_SILHOUETTE,
    ],
  },
  {
    ...requiredAndUnique,
    type: TYPE.MATERIAL,
    values:
      shape === DEPORTE_SHAPE.DEPORTE
        ? [
            DEPORTE_MATERIAL.RESINE_3D,
            {
              value: DEPORTE_MATERIAL.SILICON_PLATNIUM_40,
              disabledCallback: (options, index) =>
                !!options
                  .filter(({name}) =>
                    [DEPORTE_SHAPE.DEPORTE_HALF_CONQUE].includes(
                      name as DEPORTE_SHAPE,
                    ),
                  )
                  .find(({selected}) => selected[index]),
            },
          ]
        : [DEPORTE_MATERIAL.RESINE_3D],
  },
  {
    ...requiredAndUnique,
    type: TYPE.COLOR,
    values: [COLOR.COLORLESS_TRANSLUCENT, COLOR.ROSE_TRANSLUCENT, COLOR.BROWN],
  },
  ...(shape === DEPORTE_SHAPE.DEPORTE
    ? ([
        {
          ...requiredAndUnique,
          type: TYPE.EAR_BUD,
          values: [],
          valuesBrandCallback: (brand) => brandEarBudMap[brand],
        },
      ] as OptionData[])
    : []),
  {
    ...unique,
    type: TYPE.DEPORTE_OPTION,
    values: [
      ...[DEPORTE_OPTION.SHORT_EPAULEMENT, DEPORTE_OPTION.LONG_EPAULEMENT].map<
        OptionValueMap
      >((value) => ({
        value,
        radioGroup: 'epaulement',
        disabledCallback: (options, index) =>
          !options
            .filter(({name}) =>
              [DEPORTE_SHAPE.DEPORTE_CONDUIT].includes(name as DEPORTE_SHAPE),
            )
            .find(({selected}) => selected[index]),
      })),
      ...[
        ...(shape === DEPORTE_SHAPE.DEPORTE
          ? [
              {
                value: DEPORTE_OPTION.FULL,
                radioGroup: 'embout',
              },
              {
                value: DEPORTE_OPTION.HOLLOW,
                radioGroup: 'embout',
              },
            ]
          : []),
      ],
      {
        value: DEPORTE_OPTION.EXTRACTION_CORD,
        radioGroup: 'cord',
        disabledCallback: (options, index) =>
          !(
            options
              .filter(({name}) =>
                [DEPORTE_MATERIAL.RESINE_3D].includes(name as DEPORTE_MATERIAL),
              )
              .find(({selected}) => selected[index]) ||
            options
              .filter(({name}) =>
                [DEPORTE_SHAPE.DEPORTE_SILHOUETTE].includes(
                  name as DEPORTE_SHAPE,
                ),
              )
              .find(({selected}) => selected[index])
          ),
      },
    ],
  },
  shape === DEPORTE_SHAPE.DEPORTE
    ? {
        ...requiredAndUnique,
        type: TYPE.EVENT_TYPE_AND_SIZE,
        values: [
          {
            value: EVENT.NONE,
            type: OPTION_GROUP_CHECK_TYPE.RADIO,
            radioGroup: 'type',
            defaultSelected: true,
          },
          ...[EVENT.PARALLEL, EVENT.GROOVED].map<OptionValueMap>((value) => ({
            value,
            type: OPTION_GROUP_CHECK_TYPE.RADIO,
            radioGroup: 'type',
          })),
          {
            value: EVENT.SPIRAL,
            type: OPTION_GROUP_CHECK_TYPE.RADIO,
            radioGroup: 'type',
            disabledCallback: (options, index) =>
              !options
                .filter(({name}) =>
                  [DEPORTE_MATERIAL.RESINE_3D].includes(
                    name as DEPORTE_MATERIAL,
                  ),
                )
                .find(({selected}) => selected[index]),
          },
          ...[EVENT.D05_MM, EVENT.D08_MM].map<OptionValueMap>((value) => ({
            value,
            type: OPTION_GROUP_CHECK_TYPE.RADIO,
            radioGroup: 'size',
            disabledCallback: (options, index) =>
              !!options
                .filter(({name}) =>
                  [EVENT.POWER_VENT, EVENT.NONE, EVENT.GROOVED].includes(
                    name as EVENT,
                  ),
                )
                .find(({selected}) => selected[index]),
          })),
          ...[
            EVENT.D10_MM,
            EVENT.D12_MM,
            EVENT.D15_MM,
            EVENT.D20_MM,
            EVENT.D25_MM,
            EVENT.D30_MM,
            EVENT.MAX,
          ].map<OptionValueMap>((value) => ({
            value,
            type: OPTION_GROUP_CHECK_TYPE.RADIO,
            radioGroup: 'size',
            disabledCallback: (options, index) =>
              !!options
                .filter(({name}) => [EVENT.NONE].includes(name as EVENT))
                .find(({selected}) => selected[index]),
          })),
          {
            value: EVENT.CUSTOM,
            type: OPTION_GROUP_CHECK_TYPE.EVENT_INPUT,
            radioGroup: 'size',
            disabledCallback: (options, index) =>
              !!options
                .filter(({name}) => [EVENT.NONE].includes(name as EVENT))
                .find(({selected}) => selected[index]),
          },
        ],
      }
    : eventSizeOptions,
  allFinishOptions,
  ...(shape === DEPORTE_SHAPE.DEPORTE
    ? ([
        {
          ...requiredAndUnique,
          type: TYPE.EARWAX_SHIELDING,
          values: [],
          valuesBrandCallback: (brand) => brandEarWaxShieldMap[brand],
        },
      ] as OptionData[])
    : []),
];

export const optionsTree: OptionsTree = {
  [PRODUCT_CATEGORY.CLASSIQUE]: {
    type: TYPE.BRAND,
    ...Object.fromEntries(
      [
        CLASSIQUE_SHAPE.CONDUIT,
        CLASSIQUE_SHAPE.CANULE_EPAULEMENT,
        CLASSIQUE_SHAPE.CANULE_DEMI_EPAULEMENT,
        CLASSIQUE_SHAPE.SQUELETTE,
        CLASSIQUE_SHAPE.FOND_CONQUE,
        CLASSIQUE_SHAPE.DEMI_CONQUE,
        CLASSIQUE_SHAPE.PINCE_CRABE,
      ].map((shape) => [
        shape,
        {
          options: getClassiqueOptions(shape),
        },
      ]),
    ),
  },
  [PRODUCT_CATEGORY.DEPORTE]: {
    type: TYPE.BRAND,
    ...Object.fromEntries(
      [
        DEPORTE_SHAPE.DEPORTE,
        DEPORTE_SHAPE.CANULE_AERO,
        DEPORTE_SHAPE.COQUE,
      ].map((shape) => [
        shape,
        {
          options: getDeporteOptions(shape),
        },
      ]),
    ),
  },
  [PRODUCT_CATEGORY.PROTECTION]: {
    type: TYPE.BRAND,
    [PROTECTION_SHAPE.SOMMEIL]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.COLORLESS_TRANSLUCENT,
            COLOR.ROSE_TRANSLUCENT,
            COLOR.RED,
            COLOR.BLUE,
            COLOR.YELLOW,
          ],
        },
      ],
    },
    [PROTECTION_SHAPE.SWEETNIGHT]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.COLORLESS_TRANSLUCENT,
            COLOR.ROSE_TRANSLUCENT,
            COLOR.RED,
            COLOR.BLUE,
            COLOR.YELLOW,
          ],
        },
      ],
    },
    [PROTECTION_SHAPE.AQUASTOP]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.RED,
            COLOR.BLUE,
            COLOR.YELLOW,
            COLOR.GREEN,
            COLOR.ORANGE,
          ],
        },
        {
          type: TYPE.OPTION,
          values: [OPTION.CORD, OPTION.CLOTHES_PIN].map((value) => ({
            value,
            isPair: true,
          })),
        },
      ],
    },
    [PROTECTION_SHAPE.OBTURATEUR]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.OBTURATEUR_PRODUCT_TYPE,
          values: [
            OBTURATEUR_PRODUCT_TYPE.ANTI_NOISE,
            OBTURATEUR_PRODUCT_TYPE.ANTI_WATER,
          ],
        },
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.COLORLESS_TRANSLUCENT,
            COLOR.ROSE_TRANSLUCENT,
            COLOR.RED,
            COLOR.BLUE,
            COLOR.YELLOW,
            COLOR.GREEN,
            COLOR.ORANGE,
            COLOR.WHITE,
            COLOR.BLACK,
            COLOR.BROWN,
          ],
        },
        {
          type: TYPE.OPTION,
          values: [OPTION.CORD, OPTION.CLOTHES_PIN].map((value) => ({
            value,
            isPair: true,
          })),
        },
      ],
    },
    [PROTECTION_SHAPE.PASSTOP_OR]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.PASSTOP_OR_PRODUCT_TYPE,
          values: [
            PASSTOR_OR_PRODUCT_TYPE.R1,
            PASSTOR_OR_PRODUCT_TYPE.R2,
            PASSTOR_OR_PRODUCT_TYPE.R3,
          ],
        },
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [COLOR.COLORLESS_TRANSLUCENT, COLOR.PASSTOP_OR_BLUE],
        },
        {
          type: TYPE.OPTION,
          values: [OPTION.CONQUE, OPTION.METAL_DETECTION],
        },
      ],
    },
    [PROTECTION_SHAPE.GAME_EAR]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.RED,
            COLOR.BLUE,
            COLOR.YELLOW,
            COLOR.GREEN,
            COLOR.ORANGE,
            COLOR.WHITE,
            COLOR.BLACK,
          ],
        },
      ],
    },
    [PROTECTION_SHAPE.AQUASON]: {
      options: [
        {
          ...unique,
          type: TYPE.OPTION,
          values: [
            {value: OPTION.FLOAT, disabledCallback: () => true, isPair: true},
            {value: OPTION.CORD_MARK, isPair: true},
          ],
        },
      ],
    },
    [PROTECTION_SHAPE.PASSTOP_EP2]: {
      options: [
        {
          ...requiredAndUnique,
          type: TYPE.COLOR,
          values: [
            COLOR.BLACK_OPAQUE,
            COLOR.GREEN_TRANSLUCENT,
            COLOR.BLUE_TRANSLUCENT,
            COLOR.COLORLESS_TRANSLUCENT,
          ].map((value) => ({value, isPair: true})),
        },
        {
          ...unique,
          type: TYPE.CORD_COLOR,
          values: [
            CORD_COLOR.BLACK,
            CORD_COLOR.GREEN,
            CORD_COLOR.BLUE,
            CORD_COLOR.ORANGE,
          ].map((value) => ({value, isPair: true})),
        },
        {
          type: TYPE.OPTION,
          values: [
            {
              value: OPTION.CORD_MARK,
              disabledCallback: (options, index) =>
                !options
                  .filter(({name}) =>
                    [
                      CORD_COLOR.BLACK,
                      CORD_COLOR.GREEN,
                      CORD_COLOR.BLUE,
                      CORD_COLOR.ORANGE,
                    ].includes(name as CORD_COLOR),
                  )
                  .find(({selected}) => selected[index]),
              isPair: true,
            },
          ],
        },
      ],
    },
    [PROTECTION_SHAPE.PASSTOP_A]: {
      options: [],
    },
  },
};
